import * as yup from 'yup';
import { TFunction } from 'react-i18next';

export function useValidator() {
  return (t: TFunction) =>
    yup.object({
      showAttachments: yup.bool().when(['attachments', 'originalAttached'], {
        is: (attachments, originalAttached) =>
          attachments.length === 0 && !originalAttached,
        then: s => s.notOneOf([true], t(
          'deviationSubmit.validation.error.attachments.attachmentOrSource'
        )),
      }),
    });
}
